import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isEmpty } from 'lodash';

@Pipe({
  name: 'enumerate'
})
export class EnumeratePipe implements PipeTransform {

  constructor(private _translateService: TranslateService) { }

  transform(
    arr: any[],
    options: {
      property?: string;
      translationKey?: string;
      convertFn?: any; // Function from UtilsService
    }[],
    seperator: ' - ' | ' ' = ' ', // Seperator between each properties
    newLine: boolean = false,
  ): string {
    if (!arr || (arr && arr.length === 0)) return '';
    const output = [];
    for (const value of arr) {
      let text = '';
      let i = 0;
      for (const option of options) {
        if (option.translationKey && option.property) {
          text += this._translateService.instant(
            (`${option.translationKey}.${value[option.property]}`).toUpperCase()
          );
        } else if (option.translationKey && !option.property) {
          text += this._translateService.instant(
            (`${option.translationKey}.${value}`).toUpperCase()
          );
        } else if (option.property && !option.translationKey) {
          text += option.convertFn ?
            option.convertFn(value[option.property]) :
            value[option.property];
        } else {
          text += option.convertFn ? option.convertFn(value) : value;
        }

        if (i < options.length - 1) text += seperator;
        i++;
      }
      output.push(text);
    }
    return output.join(newLine ? '<br/>' : ', ');
  }

}
